const MINIMUM_NAME_LENGTH = 3;
const MINIMUM_INDIVIDUAL_NAME_LENGTH = 2;
const MINIMUM_PHONE_LENGTH = 10;
const MINIMUM_YEAR = 1900;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const NAME_REGEX = /^[a-zA-ZÀ-ÿ\s'-]+$/;
const CARD_NUMBER_REGEX = /^[0-9]{13}$/;

const validateFullName = (value) => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return "Le nom et prénom sont requis";
  }

  if (trimmedValue.length < MINIMUM_NAME_LENGTH) {
    return "Le nom et prénom doivent contenir au moins 3 caractères";
  }

  if (!NAME_REGEX.test(trimmedValue)) {
    return "Le nom et prénom ne doivent contenir que des lettres";
  }

  if (!trimmedValue.includes(' ')) {
    return "Veuillez saisir votre nom et votre prénom";
  }

  const [firstName, ...lastNameParts] = trimmedValue.split(' ');
  const lastName = lastNameParts.join(' ');

  if (firstName.length < MINIMUM_INDIVIDUAL_NAME_LENGTH || lastName.length < MINIMUM_INDIVIDUAL_NAME_LENGTH) {
    return "Le prénom et le nom doivent contenir au moins 2 caractères chacun";
  }

  return '';
};

const validateEmail = (value) => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return "L'email est requis";
  }

  if (!EMAIL_REGEX.test(trimmedValue)) {
    return "L'email n'est pas valide";
  }

  return '';
};

const validatePhone = (value) => {
  if (!value) {
    return "Le numéro de téléphone est requis";
  }

  if (value.length < MINIMUM_PHONE_LENGTH) {
    return "Le numéro de téléphone n'est pas valide";
  }

  return '';
};

const validateBirthDate = (value) => {
  const { day, month, year } = value;

  if (day === '' || month === '' || year === '') {
    return "La date de naissance est requise";
  }

  if (year.length < 4) {
    return "L'année doit être supérieure à 1900";
  }

  const birthDate = new Date(year, month - 1, day);
  const currentDate = new Date();

  if (birthDate > currentDate) {
    return "La date ne peut pas être dans le futur";
  }

  if (birthDate.getFullYear() < MINIMUM_YEAR) {
    return "L'année doit être supérieure à 1900";
  }

  return '';
};

export const validateField = (fieldName, value) => {
  switch(fieldName) {
    case 'fullName': {
      return validateFullName(value);
    }
    case 'email': {
      return validateEmail(value);
    }
    case 'phone': {
      return validatePhone(value);
    }
    case 'birthDate': {
      return validateBirthDate(value);
    }
    default: {
      return '';
    }
  }
};

export const isCardNumberValid = (fidCardNumber) => {
  return CARD_NUMBER_REGEX.test(fidCardNumber);
};

export const getJustPhoneNumber = (phoneNumber, dialCode) => {
  let cleanedPhoneNumber = phoneNumber;

  if (cleanedPhoneNumber.startsWith('+')) {
    cleanedPhoneNumber = cleanedPhoneNumber.slice(1);
  }

  return cleanedPhoneNumber.replace(dialCode, '');
};
